import { useState } from "react";
import dayjs from "dayjs";
import { Input, Table } from "antd";

import { OPTIONS_INVESTMENT_OBJECTIVE } from "../../../../constant";

const SectionHome = ({ dataSource, loading, onProposalClick }) => {
  const [searchedText, setSearchedText] = useState("");

  const columns = [
    {
      render: allValues => (
        <a onClick={() => onProposalClick(allValues.email)}>
          {
            OPTIONS_INVESTMENT_OBJECTIVE.find(
              it => it.value === allValues.investmentObjective
            )?.label
          }
        </a>
      ),
      title: "Proposal(s)",
    },
    {
      filteredValue: [searchedText],
      onFilter: (value, record) =>
        String(record.clientName).toLowerCase().includes(value.toLowerCase()) ||
        String(record.email).toLowerCase().includes(value.toLowerCase()),
      render: allValues => (
        <a onClick={() => onProposalClick(allValues.email)}>
          {allValues.firstName} {allValues.lastName}
        </a>
      ),
      sorter: (a, b) =>
        `${a.firstName} ${a.lastName}`.localeCompare(
          `${b.firstName} ${b.lastName}`
        ),
      title: "Client Name",
    },
    {
      render: allValues => allValues.advisorName,
      title: "Advisor",
    },
    {
      render: allValues => (allValues.archivedAt ? "Archived" : "Active"),
      title: "Status",
    },
    {
      render: allValues => (
        <span style={{ textTransform: "capitalize" }}>
          {allValues.riskTolerance}
        </span>
      ),
      title: "Risk Category",
    },
    {
      render: allValues =>
        allValues.updatedAt && dayjs(allValues.updatedAt).format("MM/DD/YYYY"),
      sorter: (a, b) => dayjs(a.updateDateTime) - dayjs(b.updateDateTime),
      title: "Created",
    },
    {
      render: () => "Pending",
      title: "Signed",
    },
  ];

  return (
    <div style={{ padding: "16px 32px" }}>
      <header>
        <h3>All Proposals</h3>
      </header>

      <main>
        <Input
          onChange={event => setSearchedText(event.target.value)}
          placeholder="Search..."
          style={{
            borderRadius: 25,
            height: 37,
            marginBottom: 8,
            maxWidth: 200,
          }}
        />
        <Table
          columns={columns}
          dataSource={dataSource}
          loading={loading}
          pagination={false}
          rowHoverable={false}
        />
      </main>
    </div>
  );
};

export default SectionHome;
